export default "https://assets-v2.scaler.com/packs/images/thumb.5ebd9f.svg";